import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Cacheable } from 'ts-cacheable';

const casheBuster$ = new Subject<void>();

@Injectable({ providedIn: 'root' })
export class DropdownService extends BaseService {
  constructor(protected readonly httpClient: HttpClient) {
    super(httpClient);
  }

  @Cacheable({ cacheBusterObserver: casheBuster$ })
  getOptions(): Observable<any> {
    return this.httpClient
      .get<any>(`standard_dropdowns`)
      .pipe(map(({ standard_dropdowns }) => standard_dropdowns));
  }
}
